export const caseInformationTabs = [
  { title: "Case details", id: "case-details", active: true },
  { title: "Related cases ", id: "related-isr-cases" },
  { title: "Attachments", id: "attachments" },
  { title: "Emails", id: "emails" },
];

export const caseDetailsForm = () => {
  return [
    {
      id: 1,
      title: "Basic Information",
      formStyle: {
        columnGap: "32px",
        border: "1px solid var(--Gray-300)",
        "border-radius": "5px",
        padding: "24px 24px 0",
      },
      fieldStyle: {
        flex: "0 31.3%",
      },
      formFields: [
        {
          id: "case_number",
          label: "Case Number",
          placeholder: "Case Number",
          type: "input",
          name: "case_number",
          disabled: () => true,
        },
        {
          id: "case_owner",
          label: "Case owner",
          placeholder: "Case owner",
          type: "input",
          name: "owner_name",
          disabled: () => true,
        },
        {
          id: "account_name",
          label: "Account Name",
          placeholder: "Account Name",
          type: "input",
          name: "account_name",
          disabled: () => true,
        },
        {
          id: "case_record_type",
          label: "Case Record Type",
          placeholder: "Case Record Type",
          type: "input",
          name: "case_record_type",
          disabled: () => true,
        },
        {
          id: "contact_name",
          label: "Contact Name",
          placeholder: "Contact Name",
          type: "input",
          name: "contact_name",
          disabled: () => true,
        },
        {
          id: "status",
          label: "Status",
          placeholder: "Status",
          type: "input",
          name: "status",
          disabled: () => true,
        },
        {
          id: "on_behalf_of_account",
          label: "On Behalf of Account",
          placeholder: "On Behalf of Account",
          type: "input",
          name: "on_behalf_account_name",
          disabled: () => true,
        },
        {
          id: "is_escalated",
          label: "Escalated",
          type: "checkbox",
          name: "is_escalated",
          disabled: () => true,
        },
        {
          id: "cluster_csce",
          label: "Cluster CS/CE",
          type: "checkbox",
          name: "cluster_csce",
          disabled: () => true,
        },
        {
          id: "type",
          label: "Type",
          placeholder: "Type",
          type: "input",
          name: "type",
          disabled: () => true,
        },
        {
          id: "sub_type",
          label: "Sub Type",
          placeholder: "Sub Type",
          type: "input",
          name: "sub_type",
          disabled: () => true,
        },
        {
          id: "reason_for_case",
          label: "Reason for Case",
          placeholder: "Reason for Case",
          type: "input",
          name: "reason_for_case",
          disabled: () => true,
        },
        {
          id: "case_channel",
          label: "Case Channel",
          placeholder: "Case Channel",
          type: "input",
          name: "case_channel",
          disabled: () => true,
        },
        {
          id: "contact_phone",
          label: "Contact phone",
          placeholder: "Contact phone",
          type: "input",
          name: "contact_phone",
          disabled: () => true,
        },
        {
          id: "contact_email",
          label: "Contact Email",
          placeholder: "Contact Email",
          type: "input",
          name: "contact_email",
          disabled: () => true,
        },
        {
          id: "scv_code",
          label: "SCV Code",
          placeholder: "SCV Code",
          type: "input",
          name: "scv_code",
          disabled: () => true,
        },
      ],
    },
    {
      id: 2,
      title: "Descriptive information",
      formStyle: {
        columnGap: "32px",
        border: "1px solid var(--Gray-300)",
        "border-radius": "5px",
        padding: "24px 24px 0",
      },
      fieldStyle: {
        flex: "0 48.3%",
      },
      formFields: [
        {
          id: "Subject",
          label: "Subject",
          placeholder: "Subject",
          type: "input",
          name: "subject",
          disabled: () => true,
        },
        {
          id: "Description",
          label: "Description",
          placeholder: "Description",
          type: "textarea",
          name: "description",
          disabled: () => true,
        },
      ],
    },
    {
      id: 3,
      title: "Case information",
      formStyle: {
        columnGap: "32px",
        border: "1px solid var(--Gray-300)",
        "border-radius": "5px",
        padding: "24px 24px 0",
      },
      fieldStyle: {
        flex: "0 31.3%",
      },
      formFields: [
        {
          id: "bol_number",
          label: "Shipment number",
          placeholder: "Shipment number",
          type: "input",
          name: "bol_number",
          disabled: () => true,
        },
        {
          id: "parent_case_number",
          label: "Parent Case",
          placeholder: "Parent Case",
          type: "input",
          name: "parent_case_number",
          disabled: () => true,
        },
      ],
    },
    {
      id: 4,
      title: "Geography Information",
      formStyle: {
        columnGap: "32px",
        border: "1px solid var(--Gray-300)",
        "border-radius": "5px",
        padding: "24px 24px 0",
      },
      fieldStyle: {
        flex: "0 31.3%",
      },
      formFields: [
        {
          id: "region_name",
          label: "Region",
          placeholder: "Region",
          type: "input",
          name: "region_name",
          disabled: () => true,
        },
        {
          id: "country_name",
          label: "Country",
          placeholder: "Country",
          type: "input",
          name: "country_name",
          disabled: () => true,
        },
        {
          id: "cluster",
          label: "Cluster",
          placeholder: "Cluster",
          type: "input",
          name: "cluster",
          disabled: () => true,
        },
      ],
    },
    {
      id: 5,
      title: "Case status information",
      formStyle: {
        columnGap: "32px",
        border: "1px solid var(--Gray-300)",
        "border-radius": "5px",
        padding: "24px 24px 0",
      },
      fieldStyle: {
        flex: "0 31.3%",
      },
      formFields: [
        {
          id: "resolved_reason",
          label: "Resolved reason",
          placeholder: "Resolved reason",
          type: "input",
          name: "resolved_reason",
          disabled: () => true,
        },
        {
          id: "response_received_flag",
          label: "Response received flag",
          placeholder: "Response received flag",
          type: "checkbox",
          name: "response_received",
          disabled: () => true,
        },
        {
          id: "case_reopened",
          label: "Case reopened",
          placeholder: "Case reopened",
          type: "checkbox",
          name: "case_reopened",
          disabled: () => true,
        },
      ],
    },
    {
      id: 6,
      title: "System Information",
      formStyle: {
        columnGap: "32px",
        border: "1px solid var(--Gray-300)",
        "border-radius": "5px",
        padding: "24px 24px 0",
      },
      fieldStyle: {
        flex: "0 31.3%",
      },
      formFields: [
        {
          id: "liner_brand",
          label: "Brand",
          placeholder: "Brand",
          type: "input",
          name: "liner_brand",
          disabled: () => true,
        },
        {
          id: "created_by",
          label: "Created By",
          placeholder: "Created By",
          type: "input",
          name: "created_by_name",
          disabled: () => true,
        },
        {
          id: "created_date",
          label: "Created Date",
          placeholder: "Provide created date",
          type: "date",
          name: "created_date",
          format: "DD-MMM-YYYY hh:mm a",
          visible: () => true,
          disabled: () => true,
        },
        {
          id: "last_modified_by",
          label: "Last Modified By",
          placeholder: "Last Modified By",
          type: "input",
          name: "last_modified_by_name",
          disabled: () => true,
        },
        {
          id: "last_modified_date",
          label: "Last Modified Date",
          placeholder: "Provide last modified date",
          type: "date",
          name: "last_modified_date",
          format: "DD-MMM-YYYY hh:mm a",
          visible: () => true,
          disabled: () => true,
        },
      ],
    },
  ];
};

export const related_isr_table_config = [
  {
    title: "Case",
    slotKey: "case_number",
    width: 160,
    isFrozen: true,
  },
  {
    title: "Subject",
    slotKey: "subject",
    width: 160,
  },
  {
    title: "Date/Time Opened",
    slotKey: "created_date",
    width: 160,
    type: "date",
  },
  {
    title: "Owner",
    slotKey: "owner_name",
    width: 160,
  },
  {
    title: "Contact name",
    slotKey: "contact_name",
    width: 160,
  },
  {
    title: "Status",
    slotKey: "status",
    width: 160,
  },
  {
    title: "Brand",
    slotKey: "liner_brand",
    width: 160,
  },
  {
    title: "Last Modified By",
    slotKey: "last_modified_by_name",
    width: 160,
  },
  {
    title: "Last Modified Date",
    slotKey: "last_modified_date",
    width: 160,
    type: "date",
  },
  {
    title: "Created By",
    slotKey: "created_by_name",
    width: 160,
  },
  {
    title: "Resolver Dept",
    slotKey: "resolver_dept",
    width: 160,
  },
  {
    title: "Account Name",
    slotKey: "account_name",
    width: 160,
  },
  {
    title: "Country",
    slotKey: "country_name",
    width: 160,
  },
  {
    title: "Case Record Type",
    slotKey: "case_record_type",
    width: 160,
  },
  {
    title: "Time With Current Owner (RH)",
    slotKey: "time_with_current_owner",
    width: 160,
  },
  {
    title: "Overall Age (RH)",
    slotKey: "overall_age",
    width: 160,
  },
];
